import React from 'react';
import TextBlock from 'components/common/helpMeDecide/TextBlock';
import withCriteria from 'components/common/helpMeDecide/withCriteria';
import { Guideline, RadioGroup } from '@insurancemenu/imenu-components-lib';
import { createStyles } from 'components/common/helpMeDecide/commonCriteriaStyles';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';

const MedicalCriteria4 = observer((): JSX.Element => {
  const classes = createStyles();

  // Mobx store
  const {
    browsingFilterStore: { onRangeFilterChangeDownUp, getFilterRangeValueDownUp },
  } = useRootStore();

  // Values for radio buttons group
  const radioButtons = [
    {
      id: '0-1000',
      label: '$0-$1000',
      value: '0-1000',
    },
    {
      id: '1000-2000',
      label: '$1000-$2000',
      value: '1000-2000',
    },
    {
      id: '2000-5000',
      label: '$2000-$5000',
      value: '2000-5000',
    },
    {
      id: '5000-10000',
      label: '$5000 and greater',
      value: '5000-10000',
    },
  ];

  return (
    <div>
      <TextBlock title="Individual Deductible" subtitle="What range in deductible would you like to see?" />
      <RadioGroup
        label=""
        value={getFilterRangeValueDownUp('Individual Deductible')}
        radioButtons={radioButtons}
        className={classes.radioButtonGroup}
        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
          onRangeFilterChangeDownUp('Individual Deductible', e.target.value);
        }}
      />
      <Guideline
        simpleStyles
        labels={{
          opened: 'What is a deductible',
          closed: 'What is a deductible',
        }}
        className={classes.guidelineWrapper}
        content={
          <>
            <ul className={classes.guidelineList}>
              <li className={classes.guidelineItem}>
                A deductible is the amount an employee must pay out of pocket each year before the health plan begins to
                cover most medical services
              </li>
              <li className={classes.guidelineItem}>
                Only covered services count toward the deductible, and not all care (like preventive services) requires
                the deductible to be met first
              </li>
              <li className={classes.guidelineItem}>
                Once the deductible is met, the plan typically begins to share costs with the employee through
                coinsurance until the out-of-pocket maximum is reached
              </li>
              <li className={classes.guidelineItem}>
                Deductibles reset annually, usually at the start of the plan year, requiring employees to meet them
                again each year
              </li>
              <li className={classes.guidelineItem}>
                Generally, the lower the deductible, the higher cost of the plan
              </li>
            </ul>
          </>
        }
      />
    </div>
  );
});

export default withCriteria(MedicalCriteria4, 4);
